module.exports = __webpack_public_path__ + "img/smcs.9a051784.png";